import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/play-circle': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M371.7 238c16.4 9.2 16.4 32.9 0 42l-176 101c-15.9 8.8-35.7-2.6-35.7-21v-208c0-18.5 19.9-29.8 35.7-21zM504 256c0 137-111 248-248 248s-248-111-248-248 111-248 248-248 248 111 248 248zM56 256c0 110.5 89.5 200 200 200s200-89.5 200-200-89.5-200-200-200-200 89.5-200 200z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/play-circle.js
// module id = 1807
// module chunks = 0